import { render, staticRenderFns } from "./CrudRegister.vue?vue&type=template&id=1a411f8c&scoped=true&"
import script from "./CrudRegister.vue?vue&type=script&lang=js&"
export * from "./CrudRegister.vue?vue&type=script&lang=js&"
import style0 from "./CrudRegister.vue?vue&type=style&index=0&id=1a411f8c&scoped=true&lang=css&"
import style1 from "./CrudRegister.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a411f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VIcon,VRow})
